module.exports = "/account/index-111d5a.html";